/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  budgetModel: null,
  budgetYear: null,
  formLoading: true,
  workorder: null,
  workorderAddModel: null,
  workorderEditModel: null,
  workorderLineItemAddModel: null,
  workorderIncentivePaymentAddModel: null,
  workorderLineItemAddedModel: null,
  workorderIncentivePaymentAddedModel: null,
  workorderLineItemEditModel: null,
  workorderLineItemEditedModel: null,
  workorderLineItemBillingCompleteModel: null,
  workorderIncentivePaymentBillingCompleteModel: null,
  errorMessage: null,
};

export const actions = {
  async getWorkorder({ commit }, workorderId) {
    await api.get(
      `workorder/${workorderId}`,
    ).then((response) => {
      commit('SET_WORKORDER', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async postWorkorder({ commit }, workorder) {
    await api.post(
      'workorder', workorder,
    ).then((response) => {
      commit('SET_WORKORDER', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async putWorkorder({ commit }, workorder) {
    await api.put(
      'workorder', workorder,
    ).then(() => {}).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async postWorkorderLineItem({ commit }, workorderLineItem) {
    await api.post(
      `workorder/${workorderLineItem.workorderId}/lineitem`, workorderLineItem,
    ).then((response) => {
      commit('SET_WORKORDER_LINEITEM_ADDED_MODEL', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async postWorkorderIncentivePayment({ commit }, workorderIncentivePayment) {
    await api.post(
      `workorder/${workorderIncentivePayment.workorderId}/incentivepayment`, workorderIncentivePayment,
    ).then((response) => {
      commit('SET_WORKORDER_INCENTIVEPAYMENT_ADDED_MODEL', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async putWorkorderLineItem({ commit }, workorderLineItem) {
    await api.put(
      `workorder/${workorderLineItem.workorderId}/lineitem`, workorderLineItem,
    ).then((response) => {
      /* eslint-disable-next-line */
      response.data.workOrderLineItemIdOld = workorderLineItem.id;
      commit('SET_WORKORDER_LINEITEM_EDITED_MODEL', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async deleteWorkorderLineItem({ commit }, lineItem) {
    commit('SET_SUCCESS_MESSAGE', '');
    await api.delete(`/workorder/${lineItem.workOrderId}/lineItem/${lineItem.workOrderLineItemId}`).then(async () => {
      commit('SET_SUCCESS_MESSAGE', 'The work order line item was deleted.');
    }).catch((error) => commit('SET_ERROR_MESSAGE', error));
  },
  setBudgetModel({ commit }, budgetModel) {
    commit('SET_BUDGETMODEL', budgetModel);
  },
  setBudgetYear({ commit }, budgetYear) {
    commit('SET_BUDGETYEAR', budgetYear);
  },
  setWorkorderAddModel({ commit }, workorderAddModel) {
    commit('SET_WORKORDER_ADD_MODEL', workorderAddModel);
  },
  setWorkorderEditModel({ commit }, workorderEditModel) {
    commit('SET_WORKORDER_EDIT_MODEL', workorderEditModel);
  },
  setWorkorderLineItemAddModel({ commit }, workorderLineItemAddModel) {
    commit('SET_WORKORDER_LINEITEM_ADD_MODEL', workorderLineItemAddModel);
  },
  setWorkorderIncentivePaymentAddModel({ commit }, workorderIncentivePaymentAddModel) {
    commit('SET_WORKORDER_INCENTIVEPAYMENT_ADD_MODEL', workorderIncentivePaymentAddModel);
  },
  setWorkorderLineItemEditModel({ commit }, workorderLineItemEditModel) {
    commit('SET_WORKORDER_LINEITEM_EDIT_MODEL', workorderLineItemEditModel);
  },
  setFormLoading({ commit }, loading) {
    commit('SET_FORMLOADING', loading);
  },
  async setWorkorderStatus({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);
    await api.put(`/workorder/${params.id}/status/${params.status}`).then(async () => {
    }).catch((exception) => {
      console.error('Enter api.put /workorder/{id}/status/{status} catch()');
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
      console.error('Exit api.put /workorder/{id}/status/{status} catch()');
    });
  },
  async setWorkorderLineItemBillingComplete({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);

    await api.put(`/WorkOrder/${params.workOrderId}/WorkOrderLineItem/${params.workOrderLineItemId}/BillingComplete/${params.billingComplete}`).then(async (response) => {
      commit('SET_WORKORDER_LINEITEM_BILLINGCOMPLETE_MODEL', response.data);
    }).catch((exception) => {
      console.error('Enter api.put /WorkOrder/{workOrderId}/WorkOrderLineItem/{workOrderLineItemId}/BillingComplete/{billingComplete} catch()');

      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);

      console.error('Exit api.put /WorkOrder/{workOrderId}/WorkOrderLineItem/{workOrderLineItemId}/BillingComplete/{billingComplete} catch()');
    });
  },
  async setWorkorderIncentivePaymentBillingComplete({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);

    await api.put(`/WorkOrder/${params.projectIncentivePaymentId}/IncentivePayment/${params.workOrderIncentivePaymentId}/BillingComplete/${params.billingComplete}`).then(async (response) => {
      commit('SET_WORKORDER_INCENTIVEPAYMENT_BILLINGCOMPLETE_MODEL', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
    });
  },
};

export const mutations = {
  SET_BUDGETMODEL(state, data) {
    state.budgetModel = data;
  },
  SET_BUDGETYEAR(state, data) {
    state.budgetYear = data;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  SET_SUCCESS_MESSAGE(state, successMessage) {
    state.successMessage = successMessage;
  },
  SET_WORKORDER(state, data) {
    state.workorder = data;
  },
  SET_WORKORDER_ADD_MODEL(state, data) {
    state.workorderAddModel = data;
  },
  SET_WORKORDER_EDIT_MODEL(state, data) {
    state.workorderEditModel = data;
  },
  SET_WORKORDER_LINEITEM_ADD_MODEL(state, data) {
    state.workorderLineItemAddModel = data;
  },
  SET_WORKORDER_INCENTIVEPAYMENT_ADD_MODEL(state, data) {
    state.workorderIncentivePaymentAddModel = data;
  },
  SET_WORKORDER_LINEITEM_ADDED_MODEL(state, data) {
    state.workorderLineItemAddedModel = data;
  },
  SET_WORKORDER_INCENTIVEPAYMENT_ADDED_MODEL(state, data) {
    state.workorderIncentivePaymentAddedModel = data;
  },
  SET_WORKORDER_LINEITEM_EDIT_MODEL(state, data) {
    state.workorderLineItemEditModel = data;
  },
  SET_WORKORDER_LINEITEM_EDITED_MODEL(state, data) {
    state.workorderLineItemEditedModel = data;
  },
  SET_WORKORDER_LINEITEM_BILLINGCOMPLETE_MODEL(state, data) {
    state.workorderLineItemBillingCompleteModel = data;
  },
  SET_WORKORDER_INCENTIVEPAYMENT_BILLINGCOMPLETE_MODEL(state, data) {
    state.workorderIncentivePaymentBillingCompleteModel = data;
  },
  SET_FORMLOADING(state, data) {
    state.formLoading = data;
  },
};
